// IE doesn't have forEach defined in NodeList
if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach
}

if (!('classList' in SVGElement.prototype)) {
    Object.defineProperty(SVGElement.prototype, 'classList', {
        get() {
            return {
                contains: className => {
                    return this.className.baseVal.split(' ').indexOf(className) !== -1
                },
            }
        },
    })
}
